import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store.jsx';
import setToken from './utils/token.jsx';
import { SET_AUTH } from './containers/Authentication/constants.jsx';
import App from './App.jsx';
import ScrollToTop from './components/Common/ScrollToTop/index.jsx';

import './styles/_index.scss';
import '../global.css';

import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Authentication
setToken(true)
const token = localStorage.getItem('is_logged_in');
if (token === 'true') {
  store.dispatch({ type: SET_AUTH })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
